'use strict';

module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// ./~/promise/index.js
// module id = 2
// module chunks = 0